import { render, staticRenderFns } from "./StatisticsUnified.vue?vue&type=template&id=b3809b40&"
import script from "./StatisticsUnified.vue?vue&type=script&lang=js&"
export * from "./StatisticsUnified.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsUnified.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports